// import.meta.env.{variable} has to be hard coded like this because it gets replaced at compilation time (make sure compatible with storybook if changing)
export const environment = {
  PUBLIC_production: import.meta.env.PUBLIC_production,
  PUBLIC_mixpanelToken: import.meta.env.PUBLIC_mixpanelToken,
  PUBLIC_REACT_APP_URL: import.meta.env.PUBLIC_REACT_APP_URL,
  PUBLIC_WEBSITE_URL: import.meta.env.PUBLIC_WEBSITE_URL,
  PUBLIC_API_ROOT: import.meta.env.PUBLIC_API_ROOT,
  PUBLIC_GO_API_ROOT: import.meta.env.PUBLIC_GO_API_ROOT,
  PUBLIC_ORY_KRATOS_URL: import.meta.env.PUBLIC_ORY_KRATOS_URL,
  PUBLIC_USER_MGMT_URL: import.meta.env.PUBLIC_USER_MGMT_URL,
  PUBLIC_HUBSPOT_TRIAL_UPGRADE_URL: import.meta.env
    .PUBLIC_HUBSPOT_TRIAL_UPGRADE_URL,
  PUBLIC_UNLEASH_URL: import.meta.env.PUBLIC_UNLEASH_URL,
  PUBLIC_UNLEASH_CLIENT_KEY: import.meta.env.PUBLIC_UNLEASH_CLIENT_KEY,
  PUBLIC_FORCE_BRAND: import.meta.env.PUBLIC_FORCE_BRAND,
  PUBLIC_WILSON_REACT_APP_URL: import.meta.env.PUBLIC_WILSON_REACT_APP_URL,
  PUBLIC_GA4_MEASUREMENT_ID: import.meta.env.PUBLIC_GA4_MEASUREMENT_ID,
  PUBLIC_GOOGLE_ADS_ID: import.meta.env.PUBLIC_GOOGLE_ADS_ID,
  PUBLIC_LINKEDIN_PARTNER_ID: import.meta.env.PUBLIC_LINKEDIN_PARTNER_ID,
  PUBLIC_HUBSPOT_PORTAL_ID: import.meta.env.PUBLIC_HUBSPOT_PORTAL_ID,
};
